import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthStore } from '../../shared/store/auth.signal-store';

import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
  PASSWORD_FORM_RULES,
  RequirementCheckComponent,
  RequirementState,
  formValidator,
} from '@stillmandigital/common';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    RequirementCheckComponent,
    TranslateModule,
  ],
})
export class ChangePasswordComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _store = inject(AuthStore);

  public readonly form = this._fb.nonNullable.group(
    {
      oldPassword: this._fb.nonNullable.control<string | undefined>(
        undefined,
        Validators.required,
      ),
      newPassword: this._fb.nonNullable.control<string | undefined>(
        undefined,
        Validators.required,
      ),
      repeatNewPassword: this._fb.nonNullable.control<string | undefined>(
        undefined,
        Validators.required,
      ),
    },
    { validators: [formValidator(PASSWORD_FORM_RULES)] },
  );

  public readonly requirements = PASSWORD_FORM_RULES.map(rule => ({
    label: rule.label,
    getState: (): RequirementState =>
      rule.isReady(this.form.getRawValue())
        ? this.form.hasError(rule.errorKey)
          ? 'error'
          : 'met'
        : 'unset',
  }));

  public change() {
    const { oldPassword, newPassword } = this.form.value;

    if (this.form.valid && oldPassword && newPassword) {
      this._store.changePassword({ oldPassword, newPassword });
    }
  }
}
